class TabelaClasseFlangeBocais {
  constructor({
    material,
    pressureClass,
    unit,
    data
  }) 
  
  {
    this.material = material;
    this.pressureClass = pressureClass;
    this.unit = unit;
    this.data = data;
  }

}

module.exports = TabelaClasseFlangeBocais;